// extracted by mini-css-extract-plugin
export var appContainer = "Zpv8T";